import React from "react";

import clsx from "clsx";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { type FetchCreativeSavedViews_me_creativeSavedViews_views } from "@north-beam/nb-client-side";
import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { useReportBodyState } from "../hooks/ca-control-state";

interface SelectedMetricProps {
  savedView: FetchCreativeSavedViews_me_creativeSavedViews_views;
  deleteView: (id: string) => void;
  isDefault: boolean;
}

export function SelectedSavedView({
  savedView,
  deleteView,
  isDefault,
}: SelectedMetricProps) {
  const { isDemoMode } = usePrefs();
  const { selectedSaveViewId } = useReportBodyState();
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: savedView.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const active = savedView.id === selectedSaveViewId;
  return (
    <div
      ref={setNodeRef}
      className={clsx(
        "m-2 rounded-md  bg-cosmic-4 hover:bg-[#F8F8FE]",
        "hover:border-[#F8F8FE] text-[12px] font-light pl-2 pr-2 py-3 ",
        "flex items-center",
      )}
      style={style}
    >
      <i
        ref={setActivatorNodeRef}
        className="fa-regular fa-sharp fa-grip-dots text-cosmic cursor-move mr-2"
        {...attributes}
        {...listeners}
      ></i>
      <span className="text-black">
        {generateAnonBase64Hash({
          value: savedView.name,
          prefix: "quick-filter",
          doAnon: isDemoMode && !savedView.isDefault,
        })}
      </span>
      {savedView.isDefault && (
        <span className="font-bold ml-2 text-cosmic">template</span>
      )}
      {isDefault && <span className="font-bold ml-2 text-cosmic">default</span>}
      {active && <span className="font-bold ml-2 text-cosmic">active</span>}
      {!savedView.isDefault && !active && (
        <i
          className="fa-regular fa-sharp fa-trash ml-auto cursor-pointer mr-2 text-danger"
          onClick={() => deleteView(savedView.id)}
        />
      )}
    </div>
  );
}
